// extracted by mini-css-extract-plugin
module.exports = {"activeTab":"sidebar_activeTab__3auAs","arrow":"sidebar_arrow__30-ZH"};